<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">
    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Unidades de Inspección</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                       aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-12">
                                    <label class="col-form-label" for="Activa" title="Habilitado = Periodo vigente o habilitado temporalmente">Habilitados</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Activa"
                                                    (onChange)="onChangeActiva($event)"
                                                    unselectable="true">
                                    </p-selectButton>
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Filtra Campañas y Periodos)</label>
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-lg-6 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="IdCampania">Campaña</label>
                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="campanias"
                                               [readonly]="campanias.length === 0"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdCampania"
                                               placeholder="-- Seleccione una Campaña --"
                                               [ngClass]="displayFieldCssNgSelect('IdCampania')"
                                               (change)="onSelectCampania($event?.Id)"
                                               notFoundText="Campaña no encontrada"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Depende de "Activa")</label>
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="IdPeriodo">Periodo</label>
                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="periodos"
                                               [readonly]="periodos.length === 0"
                                               bindLabel="DescripcionPeriodo"
                                               bindValue="Id"
                                               formControlName="IdPeriodo"
                                               placeholder="-- Seleccione un Periodo --"
                                               [ngClass]="displayFieldCssNgSelect('IdPeriodo')"
                                               (change)="onSelectPeriodo($event?.Id)"
                                               notFoundText="Periodo no encontrado"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.DescripcionPeriodo }}">{{ item.DescripcionPeriodo }}</div>
                                        </ng-template>
                                    </ng-select>
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Depende de "Activa" y "Campaña")</label>
                                    </div>
                                </div>

                                <div *ngIf="!isCA" class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="IdCA">Comunidad Autónoma</label>
                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="CAs"
                                               [readonly]="CAs.length === 0"
                                               placeholder="-- Seleccione una C.A. --"
                                               [loading]="CAs.length === 0 && (form.value.IdCampania !== null && form.value.IdCampania !== 0)"
                                               bindLabel="ComunidadAutonoma"
                                               bindValue="IdCa"
                                               formControlName="IdCA"
                                               [ngClass]="displayFieldCssNgSelect('IdCA')"
                                               (change)="onSelectComunidadAutonoma($event)"
                                               notFoundText="C.A. no encontrada"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.ComunidadAutonoma }}">{{ item.ComunidadAutonoma }}</div>
                                        </ng-template>
                                    </ng-select>
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Todas o del "Periodo")</label>
                                    </div>
                                </div>

                            </div>
                            <div class="row">

                                <div *ngIf="!isEA" class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="IdEntidadAuditora">Entidad Auditora</label>
                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="EAs"
                                               [readonly]="(EAs.length === 0 && form.value.IdCA !== null && form.value.IdCA !== 0) || !entidadAuditoraEnabledForCA"
                                               placeholder="-- Seleccione una E.A. --"
                                               [loading]="EAs === null && (form.value.IdCA !== null && form.value.IdCA !== 0 && form.value.IdPeriodo !== null)"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdEntidadAuditora"
                                               [ngClass]="displayFieldCssNgSelect('IdEntidadAuditora')"
                                               (change)="onSelectEntidadAuditora($event)"
                                               notFoundText="E.A. no encontrada"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                    <div class="invalid-feedback tip d-block">
                                        <label>(depende de "Periodo" y "C.A.")</label>
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="IdTipoSolicitudCam">Tipo de Solicitud </label>
                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="tiposSolicitud"
                                               [readonly]="tiposSolicitud.length === 0"
                                               placeholder="-- Seleccione un Tipo de Solicitud --"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdTipoSolicitudCam"
                                               [ngClass]="displayFieldCssNgSelect('IdTipoSolicitudCam')"
                                               (change)="onSelectTipoSolicitud($event)"
                                               notFoundText="Tipo de Recinto no encontrado"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                    <div class="invalid-feedback tip d-block">
                                        <label ngbTooltip="PIAEd = Parcela-Invernadero-Almacén-Empresa Deshidratadora">(o Recinto "PIAEd")</label>
                                    </div>                                    
                                </div>

                                <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="IdEstadoUnidadInspeccion">Estado de la Ud. Inspección</label>
                                    <ng-select appendTo="body" #selectEstado
                                               loadingText="Cargando..."
                                               [items]="estadosUnidadInspeccion"
                                               [readonly]="estadosUnidadInspeccion.length === 0"
                                               placeholder="-- Seleccione un Estado --"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdEstadoUnidadInspeccion"
                                               [ngClass]="displayFieldCssNgSelect('IdEstadoUnidadInspeccion')"
                                               notFoundText="Estado no encontrado"
                                               clearAllText="Eliminar selección">

                                        <ng-template ng-label-tmp let-item="item">
                                            <img src="{{ item.Id | IconoEstadoUnidadInspeccion }}" ngbTooltip="{{ item.Descripcion }}" />
                                            <span ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</span>
                                        </ng-template>

                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <img src="{{ item.Id | IconoEstadoUnidadInspeccion }}" ngbTooltip="{{ item.Descripcion }}" />
                                            <span ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</span>
                                        </ng-template>

                                    </ng-select>
                                </div>

                                <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="CodigoUhc">Código Ud. de Inspección</label>
                                    <input formControlName="CodigoUhc" name="CodigoUhc" maxlength="6"
                                           class="form-control" id="CodigoUhc" type="text" value="">
                                </div>
                            </div>
                            <div class="row">

                                <div class="form-group col-xl-2 col-lg-4 col-md-2 col-sm-2">
                                    <label class="col-form-label" for="IdProvincia">Provincia</label>
                                    <ng-select appendTo="body"
                                                loadingText="Cargando..."
                                                [items]="provincias"
                                                [readonly]="provincias.length === 0"
                                                placeholder="-- Seleccione una Provincia --"
                                                [loading]="provincias.length === 0 && (form.value.IdCA !== 0 && form.value.IdCA !== null)"
                                                bindLabel="Descripcion"
                                                bindValue="Id"
                                                formControlName="IdProvincia"
                                                [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                                (change)="onSelectProvincia($event)"
                                                notFoundText="Provincia no encontrada"
                                                clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-xl-2 col-lg-4 col-md-2 col-sm-2">
                                    <label class="col-form-label" for="IdMunicipio">Municipio</label>
                                    <ng-select appendTo="body"
                                                loadingText="Cargando..."
                                                [items]="municipios"
                                                [readonly]="municipios.length === 0"
                                                placeholder="-- Seleccione un Municipio --"
                                                [loading]="municipios.length === 0 && (form.value.IdProvincia !== 0 && form.value.IdProvincia !== null)"
                                                bindLabel="Descripcion"
                                                bindValue="Id"
                                                formControlName="IdMunicipio"
                                                [ngClass]="displayFieldCssNgSelect('IdMunicipio')"
                                                notFoundText="Municipio no encontrado"
                                                clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-xl-1 col-lg-4 col-md-2 col-sm-2">
                                    <label class="col-form-label" for="NumeroRegistro" ngbTooltip="Número de Registro de la Empresa Deshidratadora">N. Registro</label>
                                    <input formControlName="NumeroRegistro" name="NumeroRegistro" maxlength="15"
                                           class="form-control" id="NumeroRegistro" type="text" value="">
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Emp.Deshidr.)</label>
                                    </div>
                                </div>

                                <div class="form-group col-xl-1 col-lg-4 col-md-2 col-sm-2">
                                    <label class="col-form-label" for="RegistroSanitario" ngbTooltip="Registro sanitario del Almacén">R. Sanitario</label>
                                    <input formControlName="RegistroSanitario" name="RegistroSanitario" maxlength="15"
                                           class="form-control" id="RegistroSanitario" type="text" value="">
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Almacén)</label>
                                    </div>
                                </div>                                

                                <!-- Se dejan comentados por si se necesitaran en un futuro -->
                                <!--
    <div class="form-group col-xl-2 col-lg-4 col-md-2 col-sm-2">
        <label class="col-form-label" for="agregado">Agregado</label>
        <input formControlName="Agregado" name="agregado" maxlength="5"
            class="form-control" id="agregado" type="text" value="">
    </div>

    <div class="form-group col-xl-2 col-lg-4 col-md-2 col-sm-2">
        <label class="col-form-label" for="zona">Zona</label>
        <input formControlName="Zona" name="zona" maxlength="5"
            class="form-control" id="zona" type="text" value="">
    </div>
    -->

                                <div class="form-group col-xl-1 col-lg-4 col-md-2 col-sm-2 sigpac">
                                    <label class="col-form-label" for="poligono">Polígono</label>
                                    <input formControlName="Poligono" name="poligono" maxlength="5"
                                            class="form-control" id="poligono" type="text" value="">
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Cód. SigPac)</label>
                                    </div>
                                </div>

                                <div class="form-group col-xl-1 col-lg-4 col-md-2 col-sm-2 sigpac">
                                    <label class="col-form-label" for="parcela">Parcela</label>
                                    <input formControlName="Parcela" name="parcela" maxlength="10"
                                            class="form-control" id="parcela" type="text" value="">
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Cód. SigPac)</label>
                                    </div>
                                </div>

                                <div class="form-group col-xl-1 col-lg-4 col-md-2 col-sm-2 sigpac">
                                    <label class="col-form-label" for="recinto">Recinto</label>
                                    <input formControlName="Recinto" name="recinto" maxlength="10"
                                            class="form-control" id="recinto" type="text" value="">
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Cód. SigPac)</label>
                                    </div>
                                </div>
                            
                                <div *ngIf="!isOperadorCam" class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="IdOperador">Operador</label>
                                    <ng-select appendTo="body"
                                        loadingText="Cargando..."
                                        [items]="operadores"
                                        [readonly]="!operadores || operadores.length === 0"
                                        placeholder="-- Seleccione un Operador --"
                                        [loading]="operadores === null"
                                        bindLabel="Descripcion"
                                        bindValue="Id"
                                        formControlName="IdOperador"
                                        [ngClass]="displayFieldCssNgSelect('IdOperador')"
                                        notFoundText="Operador no encontrado"
                                        clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit"
                                                [disabled]="disableSearchBtn" title="Realiza una búsqueda" (click)="onSearch($event)">
                                            <i class="fa fa-search"></i> Buscar
                                        </button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button"
                                                [disabled]="formIsUntouched()"
                                                title="Limpia los filtros" (click)="resetForm($event)">
                                            <i class="fa fa-eraser"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</form>

